  import { Home, Bell, Bookmark, MessageSquare, Code, Settings, Bot } from 'lucide-react';
  import type { NavItem, ChatItem } from './sidebar.types';

  export const NAV_ITEMS: NavItem[] = [
    { id: 'home', label: 'Home', icon: Home, qa_visibility: false },
    // { id: 'notifications', label: 'Notifications', icon: Bell },
    // { id: 'saved', label: 'Saved Items', icon: Bookmark },
    { id: 'agents', label: 'My Agents', icon: Bot, qa_visibility: true },
    { id: 'cards-mockup', label: 'Cards Mockup', icon: Bot, qa_visibility: true },
    { id: 'chats', label: 'My Conversations', icon: MessageSquare, qa_visibility: true },
    { id: 'devkit', label: 'DevKit', icon: Code, qa_visibility: false },
    { id: 'admin', label: 'Admin', icon: Settings, qa_visibility: false },
  ];

  export const SAMPLE_CHATS: ChatItem[] = [
    { id: 1, title: 'Setting up new VPN access', category: 'Technology' },
    { id: 2, title: 'Benefits enrollment questions', category: 'HR' },
    { id: 3, title: 'Travel approval for Q1 2026', category: 'Travel' },
    { id: 4, title: 'Vendor contract negotiation', category: 'Procurement' },
    { id: 5, title: 'Laptop upgrade request', category: 'Technology' },
    { id: 6, title: 'PTO policy clarification', category: 'HR' },
    { id: 7, title: 'Office supplies order', category: 'Procurement' },
    { id: 8, title: 'Expense report submission', category: 'Travel' },
  ];

  export const AGENTS = [
    { id: 1, title: 'Rights AI', category: 'Agent' }
  ];
